module.exports = __webpack_public_path__ + "static/media/main idea.e9d9a915.mp3";